const GulfDistrict = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      enable-background="new 0 0 256 256"
      xmlSpace="preserve"
    >
      <metadata>
        {" "}
        Svg Vector Icons : http://www.onlinewebfonts.com/icon{" "}
      </metadata>
      <g>
        <g>
          <path d="M212.6,94.7c0,12.6-3.9,24.4-10.2,36.2c-8.7,17.3-19.7,32.3-31.5,47.2c-11,13.4-23.6,26.8-36.2,38.6c-4.7,3.9-8.7,4.7-13.4,0c-23.6-21.3-45.6-44.9-62.2-72.4c-1.6-4.7-3.9-9.4-6.3-14.2c-2.4-4.7,0-9.4,3.9-11c3.2-1.6,7.9,0.8,10.2,5.5c9.4,21.3,24.4,39.4,40.1,56.7c6.3,6.3,13.4,13.4,19.7,19.7c0.8,0.8,1.6,1.6,2.4,0c25.2-22.8,41.7-43.3,56.7-70.8c3.9-7.9,9.4-18.1,11-27.6c1.6-13.4-1.6-27.5-7.9-39.4c-12.6-22.9-33.1-36.2-59-37C100,25.4,72.5,45.1,63,73.4c-2.4,7.1-3.2,14.2-3.2,22c0,5.5-3.2,9.4-7.9,9.4s-7.9-4.7-7.9-9.4c0-40.1,27.5-74,66.1-82.6c32.3-7.1,66.1,6.3,85.8,33.1C207.1,59.3,212.6,75.8,212.6,94.7L212.6,94.7z" />
          <path d="M30.7,229.3h193.7c0-0.8-0.8-1.6-1.6-2.4c-7.9-14.2-16.5-29.1-24.4-43.3c-1.6-3.2-2.4-7.9,0-10.2c0.8-1.6,3.2-3.2,4.7-3.2c3.2,0,6.3,0.8,7.9,3.2c11,19.7,22.8,39.4,33.9,59c3.2,6.3-0.8,12.6-7.9,12.6c-37.8,0-75.6,0-113.4,0c-34.6,0-69.3,0-103.9,0c-7.9,0-12.6-7.1-7.9-14.2c11-18.9,22-37.8,32.3-56.7c2.4-3.9,6.3-5.5,9.4-4.7c5.5,1.6,6.3,8.7,3.2,14.2C51.2,193.9,33.9,223.8,30.7,229.3L30.7,229.3z" />
          <path d="M162.2,93.1c0,18.9-15,33.9-33.9,33.9c-18.9,0-33.9-15-33.9-33.9c0-18.9,15-33.9,33.9-33.9C147.2,59.3,162.2,75,162.2,93.1L162.2,93.1z M128.3,75c-10.2,0-18.1,7.9-18.1,18.1c0,10.2,7.9,18.1,18.1,18.1c9.4,0,18.1-8.7,18.1-18.1C146.5,82.9,137.8,75,128.3,75L128.3,75z" />
        </g>
      </g>
    </svg>
  );
};
export default GulfDistrict;
